import { ModalProps } from 'antd';
import { useState } from 'react';

export default function useModalState() {
  const [modal, setModal] = useState<ModalProps>({ open: false });

  function openModal(modal: Omit<ModalProps, 'open' | 'destroyOnHidden' | 'onCancel'>) {
    setModal({
      open: true,
      onCancel: closeModal,
      destroyOnHidden: true,
      ...modal
    });
  }

  function closeModal() {
    setModal({ open: false });
  }

  return { openModal, closeModal, modal };
}
